var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApiKeys(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 8.9999C13.5023 6.1577 11.3387 3.78185 8.50869 3.51897C5.67867 3.2561 3.11448 5.1928 2.59327 7.98681C2.07207 10.7808 3.76554 13.5118 6.5 14.2869V15.4999L5.5 16.4999L6.5 17.4999V18.4999L5.5 19.4999L6.5 20.4999V21.9999L8 23.4999L9.5 21.9999V14.2869C11.865 13.6165 13.498 11.4581 13.5 8.9999Z",
    stroke: "#181B5E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 9.49805C9.10457 9.49805 10 8.60262 10 7.49805C10 6.39348 9.10457 5.49805 8 5.49805C6.89543 5.49805 6 6.39348 6 7.49805C6 8.60262 6.89543 9.49805 8 9.49805Z",
    stroke: "#181B5E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 15.0131C11.1771 15.9758 13.2363 15.9883 14.925 15.0461L16 16.0001V17.5001H17.5L18 18.0251V19.5001H19.317L20.379 20.5001H22.5V18.3791L17.046 12.9251C18.056 11.1125 17.9599 8.88574 16.7976 7.16688C15.6352 5.44803 13.6043 4.52967 11.546 4.79208",
    stroke: "#181B5E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 7V2.5C8 1.39543 8.89543 0.5 10 0.5C11.1046 0.5 12 1.39543 12 2.5V4.753",
    stroke: "#181B5E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiKeys);
export default __webpack_public_path__ + "static/media/api-keys.98d7b60226c664bb9eb4ab9fc963071d.svg";
export { ForwardRef as ReactComponent };